import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import type { KeyboardEvent } from "react";
import { useState } from "react";

interface BiAgentInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
}

export const BiAgentInput = ({ onSend, disabled }: BiAgentInputProps) => {
  const [value, setValue] = useState("");

  const handleSend = () => {
    const trimmedValue = value.trim();
    if (trimmedValue && !disabled) {
      onSend(trimmedValue);
      setValue("");
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSend();
    }
  };

  return (
    <Box sx={{ display: "flex", p: 2 }}>
      <TextField
        fullWidth
        multiline
        rows={3}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Describe what you need..."
        disabled={disabled}
        size="small"
        slotProps={{
          input: {
            slotProps: {
              notchedOutline: {
                sx: {
                  borderColor: "divider",
                },
              },
            },
            sx: { borderRadius: 2, p: 1.5 },
            endAdornment: (
              <InputAdornment position="end" sx={{ alignSelf: "flex-end" }}>
                <IconButton
                  onClick={handleSend}
                  disabled={disabled || !value.trim()}
                  aria-label="Send message"
                  sx={{
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    "&.Mui-disabled": {
                      bgcolor: "action.disabledBackground",
                    },
                    "&:hover": {
                      bgcolor: "primary.dark",
                    },
                  }}
                >
                  <SendRoundedIcon />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};
